// extracted by mini-css-extract-plugin
export default {"main-container":"QuickbooksCallback_main-container__i-qIO"};